import axios from "axios"

const fetchScripts = async () => {
  try {
    const response = await axios.post("https://cms.skimountain.pl/graphql", {
      query: `query {
            optionsPage {
              acfOptions {
                customScripts {
                  type
                  settings {
                    uniqueName
                    noscript
                    postBody
                  }
                  data
                }
              }
            }
          }
        `,
    })

    const data = response.data

    return data.data.optionsPage.acfOptions.customScripts
  } catch (error) {
    console.log(error)

    return undefined
  }
}

export default fetchScripts
